import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNumber = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .4,
			d: "M2.81324 14.3678C2.92868 13.6822 3.04062 12.9966 3.15605 12.3145C3.28198 11.5694 3.40441 10.8208 3.53034 10.0757C3.7787 8.58205 4.02707 7.09188 4.27543 5.59822C5.03101 5.59822 5.79008 5.59822 6.54566 5.59822C6.2973 7.09188 6.04894 8.58205 5.80058 10.0757L5.42629 12.3145C5.29336 13.1225 5.15694 13.9306 5.02401 14.7386C4.93306 15.2843 4.45733 15.6726 3.91863 15.6726C3.85916 15.6726 3.79619 15.6691 3.73323 15.6586C3.12457 15.5572 2.7118 14.98 2.81324 14.3713V14.3678ZM4.64972 3.35946L5.05199 0.935317C5.15344 0.326656 5.73061 -0.0861135 6.33928 0.0153299C6.94794 0.116773 7.36071 0.693951 7.25926 1.30261L6.91995 3.35946H4.64972ZM8.41012 14.3678L8.75293 12.3145H11.0232L10.6209 14.7386C10.5299 15.2843 10.0542 15.6726 9.5155 15.6726C9.45604 15.6726 9.39307 15.6691 9.33011 15.6586C8.72145 15.5572 8.30868 14.98 8.41012 14.3713V14.3678ZM9.12722 10.0757C9.37558 8.58205 9.62394 7.09188 9.8723 5.59822L10.2466 3.35946C10.3795 2.55142 10.5159 1.74337 10.6489 0.935317C10.7503 0.326656 11.3275 -0.0861135 11.9362 0.0153299C12.4853 0.109777 12.8736 0.582014 12.8736 1.12071C12.8736 1.18018 12.8701 1.24314 12.8596 1.30611C12.7442 1.99173 12.6323 2.67734 12.5168 3.35946C12.3909 4.10455 12.2685 4.85313 12.1425 5.59822C11.8942 7.09188 11.6458 8.58205 11.3975 10.0757H9.12722Z",
			fill: "url(#paint0_linear_7940_104533)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.2458 3.35938H2.23875C1.6196 3.35938 1.11938 3.8596 1.11938 4.47875C1.11938 5.09791 1.6196 5.59813 2.23875 5.59813H9.87149L10.2458 3.35938ZM12.1417 5.59813H14.5519C15.171 5.59813 15.6713 5.09791 15.6713 4.47875C15.6713 3.8596 15.171 3.35938 14.5519 3.35938H12.516L12.1417 5.59813ZM5.42547 12.3144H13.4325C14.0517 12.3144 14.5519 11.8142 14.5519 11.195C14.5519 10.5758 14.0517 10.0756 13.4325 10.0756H5.79976L5.42547 12.3144ZM3.52953 10.0756H1.11938C0.500221 10.0756 0 10.5758 0 11.195C0 11.8142 0.500221 12.3144 1.11938 12.3144H3.15524L3.52953 10.0756Z",
			fill: "url(#paint1_linear_7940_104533)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_7940_104533",
			x1: 2.79791,
			y1: 7.8363,
			x2: 12.8736,
			y2: 7.8363,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#1D7FB6" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#01D5AB"
			})]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_7940_104533",
			x1: 0,
			y1: 7.83688,
			x2: 15.6713,
			y2: 7.83688,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#1D7FB6" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#01D5AB"
			})]
		})] })
	]
});
export { SvgNumber as ReactComponent };
